var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'relative',
    'flex',
    'gap-x-0 xs:gap-x-2',
    'justify-end',
    'items-center',
    _vm.isStream ? 'h-10 pr-2' : 'h-[38px] pr-1.5' ]},[_c('OzButton',{class:[
      'h-6',
      'rounded-lg',
      'bg-transparent' ].concat( (_vm.colorScheme === 'dark'
        ? [
            'text-light-text-200',
            'hover-hover:hover:bg-light-text-400',
            'active:bg-light-text-400',
            'focus:bg-light-text-400' ]
        : [
            'text-dark-text-200',
            'hover-hover:hover:bg-dark-text-100',
            'hover-hover:hover:bg-opacity-10',
            'active:bg-dark-text-100',
            'active:bg-opacity-10',
            'focus:bg-dark-text-100',
            'focus:bg-opacity-10' ]) ),attrs:{"type":"custom","x-text-padding":false,"font-size":12,"should-fix-height":false,"font-weight":"bold","aria-label":_vm.__('Remove'),"title":_vm.__('Remove')},on:{"click":function($event){$event.stopPropagation();return _vm.deletePost($event)}}},[_c('div',{staticClass:"px-1.5 mb-px self-center"},[_vm._v(_vm._s(_vm.__('Remove')))])]),_vm._v(" "),_c('OzButton',{class:['h-6', 'rounded-lg'],attrs:{"color-scheme":"primary","font-size":12,"should-fix-height":false,"x-text-padding":false,"is-custom-border-radius":true,"font-weight":"bold","aria-label":_vm.__('Approve'),"title":_vm.__('Approve')},on:{"click":function($event){$event.stopPropagation();return _vm.approve($event)}}},[_c('div',{staticClass:"px-1.5 mb-px self-center"},[_vm._v(_vm._s(_vm.__('Approve')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }